// @ts-nocheck
/* ==========================================================================
   Hot Sale — captação de lead (Shopify + HubSpot em um único envio)
   Baseado em hero-bf-form.js (LP Black Friday).

   Fluxo do submit:
   1) valida os campos (máscara/DDI por país: CO, MX, AR, BR);
   2) preenche os campos ocultos que o form de cliente da Shopify recebe;
   3) posta na HubSpot Forms Submission API v3 (keepalive, timeout curto);
   4) espera o hCaptcha da Shopify estar vinculado ao form
      (data-hcaptcha-bound="true"). Para não pagar esse tempo no clique, o
      vínculo é feito antes, via Shopify.captcha.protect(), na primeira
      interação com o form (ou alguns segundos após o carregamento).
      Na 1ª passada do submit, o listener do hCaptcha é barrado com
      stopImmediatePropagation: depois de vinculado, ele envia o form sozinho
      em QUALQUER submit, até nos inválidos;
   5) libera o envio nativo com form.requestSubmit(), que dispara um evento de
      submit real — necessário para a proteção hCaptcha da Shopify injetar o
      token (form.submit() pula esse evento e gera "Missing CAPTCHA token").

   Tela de sucesso:
   - Botão [data-hot-sale-coupon-copy] copia o cupom (mesma lógica da LP
     Black Friday). É ligado direto no documento, sem depender do form, porque
     na página de sucesso o form não é renderizado.
   ========================================================================== */
(function () {
  'use strict';

  var HUBSPOT_TIMEOUT_MS = 1500; // fetch usa keepalive: termina mesmo após o redirect
  var CAPTCHA_BIND_TIMEOUT_MS = 10000;
  var CAPTCHA_PREBIND_DELAY_MS = 3000;

  var PHONE_COUNTRY_CONFIG = {
    CO: { dialCode: '57', nationalLength: [10], mobilePrefix: '', groups: [3, 3, 4], sep: [' ', ' '] },
    MX: { dialCode: '52', nationalLength: [10], mobilePrefix: '', legacyPrefix: '1', groups: [2, 4, 4], sep: [' ', ' '] },
    AR: { dialCode: '54', nationalLength: [10], mobilePrefix: '9', groups: [2, 4, 4], sep: [' ', '-'], stripMobile15: true, twoDigitAreas: ['11'] },
    BR: { dialCode: '55', nationalLength: [10, 11], mobilePrefix: '', groups: [2, 5, 4], sep: [') ', '-'], wrapFirst: '(' },
  };

  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
  var UTM_STORAGE_KEY = 'madesa_hot_sale_utm';

  // ---------------------------------------------------------------- helpers

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email);
  }

  function getPhoneConfig(country) {
    return PHONE_COUNTRY_CONFIG[country] || PHONE_COUNTRY_CONFIG.CO;
  }

  function getPhoneCountry(form) {
    var explicit = (form.dataset.phoneCountry || '').trim().toUpperCase();
    if (PHONE_COUNTRY_CONFIG[explicit]) return explicit;

    var nac = (form.dataset.hsNacionalidade || '').trim().toLowerCase();
    if (nac.indexOf('colomb') > -1) return 'CO';
    if (nac.indexOf('argent') > -1) return 'AR';
    if (nac.indexOf('xico') > -1) return 'MX';
    if (nac.indexOf('brasil') > -1 || nac.indexOf('brazil') > -1) return 'BR';
    return 'CO';
  }

  function maxNationalLength(config) {
    return Math.max.apply(null, config.nationalLength);
  }

  // Remove DDI digitado, zeros à esquerda e o "15" de celular argentino.
  function normalizeNationalDigits(value, config) {
    var digits = (value || '').replace(/\D/g, '').replace(/^0+/, '');
    var max = maxNationalLength(config);
    if (config.dialCode && digits.indexOf(config.dialCode) === 0 && digits.length > max + 1) {
      digits = digits.slice(config.dialCode.length);
    }
    // Prefixo de celular (AR: 9) ou prefixo legado (MX: 1) digitado antes do número.
    [config.mobilePrefix, config.legacyPrefix].forEach(function (prefix) {
      if (prefix && digits.length === max + prefix.length && digits.indexOf(prefix) === 0) {
        digits = digits.slice(prefix.length);
      }
    });
    if (config.stripMobile15) {
      var area = (config.twoDigitAreas || []).indexOf(digits.slice(0, 2)) > -1 ? 2 : 3;
      if (digits.length > 10 && digits.slice(area, area + 2) === '15') {
        digits = digits.slice(0, area) + digits.slice(area + 2);
      }
    }
    return digits;
  }

  function formatPhoneMask(value, config) {
    var digits = (value || '').replace(/\D/g, '').slice(0, maxNationalLength(config) + 2);
    var groups = config.groups;
    // Brasil fixo (10 dígitos) usa 4 no meio.
    if (config === PHONE_COUNTRY_CONFIG.BR && digits.length <= 10) groups = [2, 4, 4];

    var out = '';
    var pos = 0;
    for (var i = 0; i < groups.length && pos < digits.length; i++) {
      var chunk = digits.slice(pos, pos + groups[i]);
      if (i === 0 && config.wrapFirst) out += config.wrapFirst;
      if (i > 0) out += config.sep[i - 1];
      out += chunk;
      pos += groups[i];
    }
    if (pos < digits.length) out += digits.slice(pos);
    return out;
  }

  function isValidPhone(value, config) {
    var national = normalizeNationalDigits(value, config);
    return config.nationalLength.indexOf(national.length) > -1;
  }

  function formatPhoneE164(value, config) {
    var national = normalizeNationalDigits(value, config);
    if (!national) return '';
    return '+' + config.dialCode + (config.mobilePrefix || '') + national;
  }

  function splitFullName(fullName) {
    var parts = fullName.trim().split(/\s+/).filter(Boolean);
    if (!parts.length) return { firstname: '', lastname: '' };
    return { firstname: parts[0], lastname: parts.slice(1).join(' ') };
  }

  function getHubspotUtk() {
    var match = document.cookie.match(/(^|;\s*)hubspotutk=([^;]*)/);
    return match ? decodeURIComponent(match[2]) : '';
  }

  function readUtmsFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var utms = {};
    UTM_KEYS.forEach(function (key) {
      var value = (params.get(key) || '').trim();
      if (value) utms[key] = value;
    });
    return utms;
  }

  // Guarda as UTMs da primeira URL da sessão: se a pessoa navegar antes de
  // enviar, a atribuição não se perde.
  function persistUtms() {
    var fromUrl = readUtmsFromUrl();
    if (!Object.keys(fromUrl).length) return;
    try { sessionStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(fromUrl)); } catch (e) {}
  }

  function getUtms() {
    var fromUrl = readUtmsFromUrl();
    if (Object.keys(fromUrl).length) return fromUrl;
    try {
      var stored = sessionStorage.getItem(UTM_STORAGE_KEY);
      return stored ? JSON.parse(stored) : {};
    } catch (e) {
      return {};
    }
  }

  function field(name, value) {
    return { objectTypeId: '0-1', name: name, value: String(value) };
  }

  function wait(ms) {
    return new Promise(function (resolve) { setTimeout(resolve, ms); });
  }

  // --------------------------------------------------- proteção hCaptcha Shopify

  function isCaptchaBound(form) {
    return form.dataset.hcaptchaBound === 'true' || form.dataset.recaptchaBound === 'true';
  }

  // Resolve quando o captcha da Shopify estiver vinculado ao form.
  // Sem captcha-bootstrap na página (proteção desativada), resolve na hora.
  // O timeout evita travar o botão se o provedor não carregar.
  function waitForCaptchaBound(form, timeoutMs) {
    if (!document.getElementById('captcha-bootstrap') || isCaptchaBound(form)) {
      return Promise.resolve();
    }
    return new Promise(function (resolve) {
      var done = false;
      var observer = null;
      function finish() {
        if (done) return;
        done = true;
        if (observer) observer.disconnect();
        clearTimeout(timer);
        resolve();
      }
      if (typeof MutationObserver === 'function') {
        observer = new MutationObserver(function () {
          if (isCaptchaBound(form)) finish();
        });
        observer.observe(form, { attributes: true, attributeFilter: ['data-hcaptcha-bound', 'data-recaptcha-bound'] });
      }
      var timer = setTimeout(finish, timeoutMs);
      // Reconfere logo após registrar o observer (o vínculo pode ter ocorrido no meio).
      if (isCaptchaBound(form)) finish();
    });
  }

  // Vincula o hCaptcha antecipadamente (carrega o provedor sem enviar nada).
  function prebindCaptcha(form) {
    if (form.dataset.hotSaleCaptchaPrebind === 'true' || isCaptchaBound(form)) return;
    var api = window.Shopify && window.Shopify.captcha;
    if (!api || typeof api.protect !== 'function') return;
    form.dataset.hotSaleCaptchaPrebind = 'true';
    try {
      api.protect(form, function () {});
    } catch (e) {
      form.dataset.hotSaleCaptchaPrebind = 'false';
      console.warn('[hot-sale] Não foi possível vincular o hCaptcha antecipadamente', e);
    }
  }

  // ------------------------------------------------------------------ form

  function initForm(form) {
    if (!form || form.dataset.hotSaleInit === 'true') return;
    form.dataset.hotSaleInit = 'true';

    var STR = {};
    var i18nEl = form.querySelector('[data-hot-sale-i18n]');
    if (i18nEl) {
      try { STR = JSON.parse(i18nEl.textContent); } catch (e) { STR = {}; }
    }

    var nameInput = form.querySelector('[data-hot-sale-name]');
    var emailInput = form.querySelector('input[name="contact[email]"]');
    var phoneInput = form.querySelector('[data-hot-sale-phone]');
    var consentInput = form.querySelector('[data-hot-sale-consent]');
    var statusEl = form.querySelector('[data-hot-sale-status]');
    var submitBtn = form.querySelector('.hot-sale-form__button');
    var submitLabel = form.querySelector('[data-hot-sale-submit-label]');
    var submitLabelDefault = submitLabel ? submitLabel.textContent.trim() : '';

    var firstNameField = form.querySelector('input[name="contact[first_name]"]');
    var lastNameField = form.querySelector('input[name="contact[last_name]"]');
    var phoneField = form.querySelector('input[name="contact[phone]"]');

    var phoneConfig = getPhoneConfig(getPhoneCountry(form));
    var consentRequired = !!(consentInput && consentInput.dataset.required === 'true');

    var hsPortalId = (form.dataset.hsPortalId || '').trim();
    var hsFormId = (form.dataset.hsFormId || '').trim();
    var hsPhoneField = (form.dataset.hsPhoneField || 'phone').trim();
    var hsNacionalidade = (form.dataset.hsNacionalidade || '').trim();
    var hsOrigem = (form.dataset.hsOrigemStaging || '').trim();

    var submitting = false;

    function showStatus(message) {
      if (!statusEl) return;
      statusEl.textContent = message || '';
      statusEl.hidden = !message;
    }

    function markInvalid(input, invalid) {
      if (input) input.setAttribute('aria-invalid', invalid ? 'true' : 'false');
    }

    function setSubmitting(state) {
      submitting = state;
      if (submitBtn) submitBtn.disabled = state;
      if (submitLabel) submitLabel.textContent = state ? STR.submitLoading || 'Enviando...' : submitLabelDefault;
    }

    function validate() {
      var nome = nameInput ? nameInput.value.trim() : '';
      var email = emailInput ? emailInput.value.trim() : '';
      var phone = phoneInput ? phoneInput.value.trim() : '';

      [nameInput, emailInput, phoneInput, consentInput].forEach(function (el) { markInvalid(el, false); });

      if ((nameInput && !nome) || (emailInput && !email) || (phoneInput && !phone)) {
        markInvalid(nameInput, nameInput && !nome);
        markInvalid(emailInput, emailInput && !email);
        markInvalid(phoneInput, phoneInput && !phone);
        return STR.validationRequired || 'Completa todos los campos.';
      }
      if (nameInput && nome.length < 3) {
        markInvalid(nameInput, true);
        return STR.validationName || '';
      }
      if (emailInput && !isValidEmail(email)) {
        markInvalid(emailInput, true);
        return STR.validationEmail || '';
      }
      if (phoneInput && !isValidPhone(phone, phoneConfig)) {
        markInvalid(phoneInput, true);
        return STR.validationPhone || '';
      }
      if (consentRequired && !consentInput.checked) {
        markInvalid(consentInput, true);
        return STR.validationConsent || '';
      }
      return '';
    }

    function buildHubSpotFields(data) {
      var fields = [
        field('email', data.email),
        field('firstname', data.firstname),
      ];
      if (data.phoneDigits) fields.push(field(hsPhoneField, data.phoneDigits));
      // Só envia o consentimento quando marcado: "false" apagaria um opt-in anterior.
      if (!consentInput || consentInput.checked) fields.push(field('madesa_email_consent', 'true'));
      if (hsNacionalidade) fields.push(field('nacionalidade', hsNacionalidade));
      if (hsOrigem) {
        fields.push(field('origem_de_cadastro_staging', hsOrigem));
        fields.push(field('origem_de_cadastro__crm__staging', hsOrigem));
        // Fuente de registro (LATAM) Staging — mesmo valor das origens acima.
        fields.push(field('fuente_de_registro__mexico_', hsOrigem));
      }
      // UTM vazia não entra: string vazia apagaria a atribuição anterior.
      var utms = getUtms();
      UTM_KEYS.forEach(function (key) {
        if (utms[key]) fields.push(field(key, utms[key]));
      });
      return fields;
    }

    // Resolve sempre: uma falha na HubSpot não pode impedir a gravação na Shopify.
    function sendToHubSpot(fields) {
      if (!hsPortalId || !hsFormId) return Promise.resolve();

      var context = { pageUri: window.location.href, pageName: document.title || window.location.pathname };
      var hutk = getHubspotUtk();
      if (hutk) context.hutk = hutk; // hutk vazio faz a API rejeitar

      return fetch(
        'https://api.hsforms.com/submissions/v3/integration/submit/' + hsPortalId + '/' + hsFormId,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ fields: fields, context: context }),
          keepalive: true,
        }
      )
        .then(function (res) {
          if (res.ok) return;
          return res.json().catch(function () { return null; }).then(function (body) {
            console.error('[hot-sale] HubSpot recusou o envio', res.status, body);
          });
        })
        .catch(function (err) {
          console.error('[hot-sale] Falha ao enviar para a HubSpot', err);
        });
    }

    function releaseNativeSubmit() {
      if (!isCaptchaBound(form) && document.getElementById('captcha-bootstrap')) {
        console.warn('[hot-sale] hCaptcha não vinculou a tempo; tentando o envio mesmo assim.');
      }
      form.dataset.hotSaleReady = 'true';
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        HTMLFormElement.prototype.submit.call(form);
      }
    }

    // ----- listeners (registrados uma única vez)

    if (phoneInput) {
      phoneInput.setAttribute('maxlength', String(maxNationalLength(phoneConfig) + 6));
      phoneInput.addEventListener('input', function () {
        phoneInput.value = formatPhoneMask(phoneInput.value, phoneConfig);
      });
    }

    [nameInput, emailInput, phoneInput].forEach(function (input) {
      if (!input) return;
      input.addEventListener('input', function () {
        if (input.getAttribute('aria-invalid') === 'true') markInvalid(input, false);
      });
    });

    if (consentInput) {
      consentInput.addEventListener('change', function () { markInvalid(consentInput, false); });
    }

    // Pré-vínculo do hCaptcha: na primeira interação com o form ou, no máximo,
    // alguns segundos depois do carregamento.
    function onFirstInteraction() {
      form.removeEventListener('focusin', onFirstInteraction);
      form.removeEventListener('pointerdown', onFirstInteraction);
      prebindCaptcha(form);
    }
    form.addEventListener('focusin', onFirstInteraction);
    form.addEventListener('pointerdown', onFirstInteraction);
    setTimeout(function () { prebindCaptcha(form); }, CAPTCHA_PREBIND_DELAY_MS);

    form.addEventListener('submit', function (event) {
      // 2ª passada (requestSubmit): deixa a Shopify e o hCaptcha seguirem.
      if (form.dataset.hotSaleReady === 'true') return;

      event.preventDefault();
      // Com o hCaptcha já vinculado, impede que ele envie o form agora
      // (ele ignora o preventDefault). Sem vínculo, deixa o evento seguir
      // para o captcha-bootstrap da Shopify fazer o vínculo.
      if (isCaptchaBound(form)) event.stopImmediatePropagation();
      if (submitting) return;

      var error = validate();
      if (error) {
        showStatus(error);
        return;
      }
      showStatus('');

      var nome = nameInput ? nameInput.value.trim() : '';
      var email = emailInput ? emailInput.value.trim() : '';
      var phoneE164 = phoneInput ? formatPhoneE164(phoneInput.value, phoneConfig) : '';
      var names = splitFullName(nome);

      // Campos que a Shopify grava.
      if (firstNameField) firstNameField.value = names.firstname || nome;
      if (lastNameField) lastNameField.value = names.lastname;
      if (phoneField) phoneField.value = phoneE164;

      setSubmitting(true);

      var hubspot = sendToHubSpot(
        buildHubSpotFields({
          email: email,
          firstname: names.firstname || nome,
          phoneDigits: phoneE164.replace(/\D/g, ''),
        })
      );

      // Libera o envio nativo só quando a HubSpot respondeu (ou estourou o
      // timeout) E o hCaptcha da Shopify já está vinculado ao form.
      Promise.all([
        Promise.race([hubspot, wait(HUBSPOT_TIMEOUT_MS)]),
        waitForCaptchaBound(form, CAPTCHA_BIND_TIMEOUT_MS),
      ]).then(releaseNativeSubmit);
    });

    // Se o navegador restaurar a página pelo botão "voltar", reabilita o form.
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) {
        form.dataset.hotSaleReady = 'false';
        setSubmitting(false);
      }
    });
  }

  // ------------------------------------------------- cupom (tela de sucesso)

  var COUPON_RESET_MS = 2000;
  var COUPON_COPIED_ICON =
    '<svg width="20" height="15" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M7.4375 14.125L21.5625 0L23.4375 1.875L7.4375 17.875L0 10.4375L1.875 8.5625L7.4375 14.125Z" fill="currentColor"/>' +
    '</svg>';

  // navigator.clipboard só existe em contexto seguro; o fallback cobre a
  // pré-visualização do editor de tema e navegadores antigos.
  function copyToClipboard(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }

    return new Promise(function (resolve, reject) {
      try {
        var area = document.createElement('textarea');
        area.value = text;
        area.setAttribute('readonly', '');
        area.style.position = 'fixed';
        area.style.top = '-1000px';
        area.style.opacity = '0';
        document.body.appendChild(area);
        area.select();
        var copied = document.execCommand('copy');
        document.body.removeChild(area);
        if (copied) resolve();
        else reject(new Error('copy-failed'));
      } catch (error) {
        reject(error);
      }
    });
  }

  function bindCouponCopy(button) {
    if (!button || button.dataset.hotSaleCopyInit === 'true') return;
    button.dataset.hotSaleCopyInit = 'true';

    var couponCode = (button.getAttribute('data-coupon-code') || '').trim();
    var labelEl = button.querySelector('[data-coupon-button-label]');
    var iconEl = button.querySelector('.hot-sale-coupon__icon');
    if (!couponCode || !labelEl) return;

    // Os rótulos vêm do editor de tema; o texto atual do botão é o fallback.
    var defaultLabel = (button.getAttribute('data-coupon-label') || labelEl.textContent || '').trim();
    var copiedLabel = (button.getAttribute('data-coupon-copied-label') || defaultLabel).trim();
    var defaultIcon = iconEl ? iconEl.innerHTML : '';
    var resetTimer = null;

    button.addEventListener('click', function () {
      copyToClipboard(couponCode).then(
        function () {
          labelEl.textContent = copiedLabel;
          if (iconEl) iconEl.innerHTML = COUPON_COPIED_ICON;
          button.classList.add('is-copied');

          clearTimeout(resetTimer);
          resetTimer = setTimeout(function () {
            labelEl.textContent = defaultLabel;
            if (iconEl) iconEl.innerHTML = defaultIcon;
            button.classList.remove('is-copied');
          }, COUPON_RESET_MS);
        },
        function (err) {
          console.warn('[hot-sale] Não foi possível copiar o cupom', err);
        }
      );
    });
  }

  // ------------------------------------------------------------------ boot

  function boot(root) {
    var scope = root || document;
    persistUtms();
    scope.querySelectorAll('[data-hot-sale-form]').forEach(initForm);
    scope.querySelectorAll('[data-hot-sale-coupon-copy]').forEach(bindCouponCopy);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();
